
<p-confirmDialog key='confirmLoginAs' #confirmLoginAs [style]="{width: '35vw'}" [closable]="false">
  <p-footer>
    <button i18n id="login-as-accept" class="btn btn-primary me-2" (click)="confirmLoginAs.accept()">OK</button>
    <button i18n id="login-as-reject" class="btn btn-secondary" (click)="confirmLoginAs.reject()">Cancel</button>
  </p-footer>
</p-confirmDialog>
